export const countryCodeList = {
  canada: {
    countryCode: 1,
    expression:
      /^(?:\+?\d{1,3}[- ]?)?\(?(?:\d{3})?\)?[- ]?\d{3}[- ]?\d{2}[- ]?\d{2}$/,
  },
}

/**
 *
 * @param {string} input - User's phone number input
 * @param {string} country - Country in lowercase
 * @example 'canada'
 */
export const validatePhoneNumber = (input, country = 'canada') => {
  const regex = new RegExp(countryCodeList[country].expression)
  return regex.test(`${input}`)
}

export const socialLinkUrlList = {
  linkedin: /http(s)?:\/\/([\w]+\.)?linkedin\.com\/in\/[A-z0-9_-]+\/?/,
  github: /http(s)?:\/\/([\w]+\.)?github\.com\/[A-z0-9_-]+\/?/,
}

export const validateURL: (input: string, type: any) => boolean = (
  input,
  type = 'linkedin'
) => {
  const regex = new RegExp(socialLinkUrlList[type])
  return regex.test(input)
}

export const numbersWithCommas = (number) => {
  if (!number) {
    number = 0
  }
  return number.toString().replace(/\B(?=(\d{3})+(?!\d))/g, ',')
}

export const parameterize = (string: string) => {
  return string
    .trim()
    .toLowerCase()
    .replace(/[^a-zA-Z0-9 -]/, '')
    .replace(/\s/g, '-')
}
